import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=820c7da0&"
import script from "./CustomerSettings.vue?vue&type=script&lang=ts&"
export * from "./CustomerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=820c7da0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports